<template>
  <div
    v-if="matchInfo.sportId === 'sr:sport:2'"
    :class="['teams-info']"
  >
    <div
      class="m-teams m-teams-basketball"
      :class="{ 'm-teams-show': visible }"
    >
      <div
        class="m-teams-data"
        @click="showTotal"
      >
        <div class="m-teams--info">
          <i
            class="m-icon-trangle down"
            :class="{
              active: !visible
            }"
          />
          Total
        </div>
      </div>

      <div
        v-if="visible"
        class="m-teams-scores"
      >
        <ul v-if="matchInfo.allScores">
          <li
            v-for="(score, index) in matchInfo.allScores"
            :key="index"
            :class="{ active: score[0] === matchStage }"
          >
            {{ Number(score[1].split(':')[0]) + Number(score[1].split(':')[1]) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import { getMatchStatusDescription } from '@ms/components/match/status.js'
import useMatchInfo from '@ms/components/match/useMatchInfo.js'

export default {
  name: 'LiveTotalScores',
  setup() {
    const { matchInfo } = useMatchInfo()

    const visible = ref(false)

    const matchStage = computed(() => {
      const { sportId, statusDescription } = matchInfo.value
      return getMatchStatusDescription({ sportId, statusDescription })
    })

    const showTotal = () => {
      visible.value = !visible.value
      if (visible.value) {
        localStorage.setItem('SHOW_LIVE_DETAIL_TOTAL', 1)
      } else {
        localStorage.setItem('SHOW_LIVE_DETAIL_TOTAL', '')
      }
    }

    onMounted(() => {
      const total = localStorage.getItem('SHOW_LIVE_DETAIL_TOTAL')
      if (total) visible.value = true
    })

    return {
      matchInfo,
      visible,
      matchStage,
      showTotal
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~wap/common/style/mixin" as mixin;

.teams-info {
  padding: 0 16px 6px;
  background: #181818;

  .m-teams-data {
    position: relative;
    z-index: 1;
    display: flex;
    flex: 1;
    padding: 0 0 0 12px;

    .data-info {
      top: 0;
      right: 0;
      display: flex;
    }
  }

  .m-teams {
    position: relative;
    z-index: 1;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      width: 100%;
      height: 28px;
      border-radius: 14px;
      background: #000;
      content: "";
    }

    .m-teams--info {
      position: relative;
      z-index: 1;
      width: unset;
      max-width: 100%;
      box-sizing: border-box;
      flex: unset;

      @include mixin.ellipsis();

      .m-team-name {
        height: 28px;
        box-sizing: border-box;
        padding: 0 12px;
        background: unset;
        line-height: 28px;

        @include mixin.ellipsis();
      }
    }

    .m-score {
      position: relative;
      z-index: 1;
      width: 36px !important;
      height: 28px !important;
      border-radius: 14px !important;
      line-height: 28px !important;
    }
  }

  .m-teams-basketball {
    display: flex;
    height: 28px;
    justify-content: space-between;
    color: #999;
    font-size: 12px;
    font-weight: 500;
    line-height: 28px;

    &.m-teams-show {
      &::before {
        display: block;
      }
    }

    .m-teams-scores {
      position: relative;
      z-index: 1;

      ul {
        display: flex;

        li {
          width: 18px;
          height: 28px;
          margin-left: 17px;
          color: #fff;
          font-size: 12px;
          text-align: center;

          &.active {
            color: #ffca27;
          }

          &:last-child {
            width: 36px;
            border-radius: 14px;
            margin-left: 13px;
            background: #2c2c2c;
            color: #ffca27;
            font-size: 14px;
          }
        }
      }
    }

    .m-icon-trangle {
      transition: transform 0.2s linear;

      @include mixin.m-icon-trangle(4px, #999999);

      &.active {
        transform: rotate(-90deg);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .teams-info  {
  background: #fff;

  .m-teams::before {
    background: #f8f8f8;
  }

  .m-teams-scores ul li {
    color: #000;

    &:last-child {
      background: #fff;
      box-shadow: 0 0 1px rgba(0, 0, 0, 18%);
      color: #ff7d1e;
    }
  }
}
</style>
